import { useMemo } from 'react';
import { FallbackColor } from '@cbhq/cds-common';
import { Box } from '@cbhq/cds-web/layout';
import { Avatar } from '@cbhq/cds-web/media/Avatar';

type AvatarItemProps = {
  initial: string;
  index?: number;
  avatarColor?: FallbackColor;
};

export function AvatarItem({ initial, avatarColor, index = 0 }: AvatarItemProps) {
  const dangerousStyle = useMemo(
    () => ({
      left: index * 20,
      zIndex: index,
    }),
    [index],
  );

  return (
    <Box position={index ? 'absolute' : undefined} style={dangerousStyle}>
      <Avatar alt={initial} name={initial} colorScheme={avatarColor} dangerouslySetSize={32} />
    </Box>
  );
}
